import { createTheme, ThemeOptions } from '@mui/material/styles';

const palette = {
  primary: {
    main: '#03387E',
    // light: '#42a5f5',
    // dark: '#1565c0',
    // contrastText: '#ffffff',
  },
  secondary: {
    main: '#F2F5F9',
  //   light: '#ba68c8',
  //   dark: '#7b1fa2',
  //   contrastText: '#ffffff',
  },
};

const defaultTheme = createTheme()
export const themeOptions: ThemeOptions = {
  palette: palette,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1800
    }
  },
  typography: {
    bannerTitle: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '1.5rem',
      fontWeight: 700,
      color: '#333',
      textShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)',
      lineHeight: 1.2,
      [defaultTheme.breakpoints.up('sm')]: {
        fontSize: '2rem',
      },
      [defaultTheme.breakpoints.up('md')]: {
        fontSize: '2.5rem',
      },
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: '2.75rem',
      }
    },
    bannerSubtitle: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '1.12rem',
      color: '#666',
      textShadow: '1px 1px 3px rgba(0, 0, 0, 0.2)',
      lineHeight: 1.2,
    },
    designTitle: {
      fontFamily: 'Inter, sans-serif',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '1rem',
      color: 'var(--brady-blue)',
      textShadow: '1px 1px 3px rgba(0, 0, 0, 0.2)',
      lineHeight: '1.2rem',
    },
    h1: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '2.25rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      // [defaultTheme.breakpoints.up('sm')]: {
      //   fontSize: '2rem',
      // },
      // [defaultTheme.breakpoints.up('md')]: {
      //   fontSize: '2.5rem',
      // },
      // [defaultTheme.breakpoints.up('lg')]: {
      //   fontSize: '2.75rem',
      // }
    },
    h3: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.2
    },
    h4: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '1.17rem',
      fontWeight: 700,
      lineHeight: 1.2
    },
    h5: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.2
    },
  },
  components: {
    MuiStack: {
      defaultProps: {
        justifyContent: 'flex-start',
        alignItems: 'center',
        useFlexGap: true,
        spacing: 2
      }
    },
    MuiDialogTitle: {
      defaultProps: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          bannerTitle: 'h1',
          bannerSubtitle: 'p',
          designTitle: 'h2'
        }
      }
    },
  },
};